import { render, staticRenderFns } from "./QrCom.vue?vue&type=template&id=e1e74e56&scoped=true"
import script from "./QrCom.vue?vue&type=script&lang=js"
export * from "./QrCom.vue?vue&type=script&lang=js"
import style0 from "./QrCom.vue?vue&type=style&index=0&id=e1e74e56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e74e56",
  null
  
)

export default component.exports